import type { Session } from "@supabase/supabase-js";

/**
 * True when React should update auth context from a Supabase auth event.
 * Repeated events for the same token must not churn React state, but a refreshed
 * access token must propagate so API and stream callers do not retain an expired token.
 */
export function isMeaningfulSessionChange(prev: Session | null, next: Session | null): boolean {
  const prevId = prev?.user.id ?? null;
  const nextId = next?.user.id ?? null;
  const prevAccessToken = prev?.access_token ?? null;
  const nextAccessToken = next?.access_token ?? null;
  return prevId !== nextId || prevAccessToken !== nextAccessToken;
}
